<div aria-labelledby="modal-title">
  <div class="modal-header">
    <h2 id="modal-title" class="modal-title" i18n="@@upp.history.rule.title">Rule history</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>

  <div class="modal-body">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          @if (isLoading()) {
          <div class="loading-container">
            <output class="spinner-border text-primary"> </output>
            <span class="ms-3" i18n="@@upp.history.rule.loading">Loading rule history...</span>
          </div>
          } @if (!isLoading()) {
          <div>
            <h5 class="mb-3" i18n="@@upp.history.rule.name" data-test="history-modal-rule-name">Rule name: {{ ruleName() }}</h5>
            <div class="ag-grid-container" data-test="history-modal-table">
              <ag-grid-angular
                class="ag-theme-alpine w-100 history-grid"
                [rowData]="rowData"
                [columnDefs]="columnDefs"
                [defaultColDef]="defaultColDef"
                [gridOptions]="gridOptions"
                [animateRows]="true"
                (gridReady)="onGridReady($event)"
              >
              </ag-grid-angular>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="close()" i18n="@@upp.history.rule.close">Close</button>
  </div>
</div>
